import React from "react";

import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import moment from "moment";

// import Validator from 'validator';
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as _ from "lodash";
import PropTypes from "prop-types";
import "react-phone-number-input/style.css";
import "react-responsive-ui/style.css";
import "react-datepicker/dist/react-datepicker.css";
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

import { DatePickerInput } from "rc-datepicker";
import "rc-datepicker/lib/style.css";

import {
  addVehicleData,
  getAllVehicleDataByUserIdAPI,
  deleteVehicleRecordsData,
  viewVehicleEditRecord
} from "../../Actions/actions";
import TextFieldGroup from "./vinTextField";

class AddVehicleInEligibility extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicleId: "",
      userId: localStorage.getItem("userId"),
      yearId: "",
      makeId: "",
      modelId: "",
      trimId: "",
      startDate: "",
      endDate: "",
      vin: "",
      cVin: "",
      vehicleCostId: "",
      vehicleTypeId: "",
      vehicleDetailQty: {},
      vehicleViewDataR: ""
    };
    this.onChange = this.onChange.bind(this);
    this._typeSelect = this._typeSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.handleSubmitVehicle = this.handleSubmitVehicle.bind(this);
    this.handleLog = this.handleLog.bind(this);
    this.handleLog1 = this.handleLog1.bind(this);

    // handleUpdateVehicle
  }

  handleChange(date) {
    // console.log(date)
    // console.log("sdasdsad",moment(date, 'DD-MMM-YYYY', true).isValid())

    if (date !== null) {
      this.setState({
        startDate: moment(date).format("YYYY-MM-DD")
      });
    }
  }

  handleChange1(date) {
    if (date !== null) {
      this.setState({
        endDate: moment(date).format("YYYY-MM-DD")
      });
    }
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {},
      errorsTermPolicy: {},
      errorsCompany: {}
    });
    this.props.functionChangeVin(e.target.value, this.props.indexValue);
  }

  async handleSubmitVehicle(e) {
    e.preventDefault();
    await this.props.viewVehicleEditRecord(this.state);
    //    console.log('dddddddddddddddddddddsssssssssss',this.state, this.state.vehicleTypeId)
  }

  handleLog(jsDate) {
    this.setState({
      endDate: jsDate
    });
    this.props.funtionchangeDate(jsDate, this.props.indexValue);
  }

  handleLog1(jsDate) {
    const purchaseNew = moment(jsDate);
    const soldNew = moment(this.state.endDate);

    if (purchaseNew > soldNew) {
      this.setState({
        endDate: null
      });
    } else {
      this.setState({
        startDate: jsDate
      });
    }
  }

  _costSelect(e) {
    this.setState({ vehicleCostId: e.value, errors: {} });
  }

  _typeSelect(e) {
    this.setState({ vehicleTypeId: e.value });
    this.props.funtionchangeSoldDate(e.value, this.props.indexValue);
  }

  componentWillMount() {
    const { vehicleDetail } = this.props;

    this.setState({
      vehicleId: vehicleDetail.vehicleDataId,
      yearId: vehicleDetail.vehicleYear,
      makeId: vehicleDetail.vehicleMake,
      modelId: vehicleDetail.vehicleModel,
      trimId: vehicleDetail.trim,
      startDate: vehicleDetail.purchaseDate,
      endDate: vehicleDetail.soldDate,
      vin: vehicleDetail.vin,
      cVin: vehicleDetail.vin,
      vehicleCostId: vehicleDetail.vehicleCost,
      vehicleTypeId: vehicleDetail.vehicleType,
      vehicleDetailQty: vehicleDetail,
      fromInfutor: vehicleDetail.fromInfutor
    });
  }

  componentDidUpdate() {
    const { vehicleDetail } = this.props;

    const { vehicleDetailQty } = this.state;
    if (vehicleDetailQty !== vehicleDetail) {
      this.setState({
        vehicleId: vehicleDetail.vehicleDataId,
        yearId: vehicleDetail.vehicleYear,
        makeId: vehicleDetail.vehicleMake,
        modelId: vehicleDetail.vehicleModel,
        trimId: vehicleDetail.trim,
        startDate: vehicleDetail.purchaseDate,
        endDate: vehicleDetail.soldDate,
        vin: vehicleDetail.vin,
        cVin: vehicleDetail.vin,
        vehicleCostId: vehicleDetail.vehicleCost,
        vehicleTypeId: vehicleDetail.vehicleType,
        vehicleDetailQty: vehicleDetail,
        fromInfutor: vehicleDetail.fromInfutor
      });
    }
  }

  handleSeletcedYearChangeConsumer(date) {
    this.setState({ cSince: date });
  }

  render() {
    const { endDate, vehicleTypeId, vin, cVin, fromInfutor } = this.state;
    const { vehicleDetail } = this.props;
    // console.log('vehicleDetail niraj',vehicleDetail)

    // this.setState({cSince : ConsumerUserData.beginYear,state:ConsumerUserData.cState});

    const optionsVehicleType = [];
    optionsVehicleType.push({
      value: "",
      label: "Current Status",
      name: "Current Status"
    });
    optionsVehicleType.push({
      value: "Still Own",
      label: "Still Owned",
      name: "Still Owned"
    });
    optionsVehicleType.push({ value: "Sold", label: "Sold", name: "Sold" });

    const cSelectedVehicleType = _.find(optionsVehicleType, {
      value: vehicleTypeId
    });
    const cDefaultVehicleType = cSelectedVehicleType;

    return (
      <div className="row veh-det-save-parent">
        <div className="col s12">
          {`${vehicleDetail.vehicleYear} ${vehicleDetail.vehicleMake} ${vehicleDetail.vehicleModel}`}
        </div>

        <div className="col s12 m4">
          <TextFieldGroup
            className="option-dropdown"
            field="vin"
            label="Vin"
            value={vin}
            cVin={cVin}
            onChange={this.onChange}
            fromInfutor={fromInfutor === 0 ? false : true}
            resetVin={() => {
              this.setState({ vin: cVin });
              this.props.functionChangeVin(cVin, this.props.indexValue);
            }}
            display
          />
        </div>

        <div className="col s12 m4">
          <Dropdown
            name="year"
            className="browser-default option-dropdown"
            options={optionsVehicleType}
            onChange={this._typeSelect}
            value={cDefaultVehicleType}
            placeholder="Current Status"
          />
        </div>
        {vehicleTypeId === "Sold" ? (
          <div className="col s12 m4">
            <DatePickerInput
              showOnInputClick
              onChange={this.handleLog}
              value={endDate}
              className="my-custom-datepicker-component"
              autoClose
              placeholder="Sold Date"
              // minDate={moment().subtract(this.state.checkYear, 'year').toDate()}
              maxDate={moment()}
              locale="en-au"
              displayFormat="MM-DD-YYYY"
              position="bottom"
            />
          </div>
        ) : (
          ""
        )}
        {/* <div className="col s12 m12 ">
          <button
            onClick={this.handleSubmitVehicle}
            className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 veh-save-det"
            type="submit"
            name="action"
          >
Save
          </button>
        </div> */}
      </div>
    );
  }
}

AddVehicleInEligibility.contextTypes = {
  router: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  data: state.data
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addVehicleData,
      getAllVehicleDataByUserIdAPI,
      deleteVehicleRecordsData,
      viewVehicleEditRecord
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddVehicleInEligibility)
);

// export default Profile;
